import intershipImg from "./artiset.jpg";
import educationIMG from "./dholakiya.jpg";
import DPUimg from "./dpu.jpg";
import hnsImg from "./hns.png";
import projectImg from "./image.png";
import projectImg3 from "./project3.png";
import projectImg4 from "./project4.png";
import projectImg5 from "./project5.png";
import projectImg6 from "./project6.png";
import projectImg7 from "./project7.png";
import projectImg8 from "./project8.png";
import projectImg9 from "./project9.png";
import TapasviIMG from "./tapasvi.jpg";
export const Bio = {
  name: "KARAN GOPLANI",
  roles: [
    "Web Developer",
  "Frontend-Focused Developer",
  "Full-Stack Project Builder",
  ],
  description:
    "I build web applications with an emphasis on clarity, usability, and practical problem solving. My work involves creating interactive user interfaces, connecting application logic with databases, and delivering reliable, well-structured solutions. I work with JavaScript, React, PHP, MySQL, and Flask, with a focus on clean implementation over unnecessary complexity.",
  github: "https://github.com/karangoplani72",
  resume:"https://drive.google.com/file/d/1mpGggUSzP4c-koM_mQSAwtP6CcdXItPu/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/karangoplani72/",
  twitter: "https://x.com/karangoplani72",
  insta: "https://www.instagram.com/karangoplani72/",
  facebook: "https://www.facebook.com/karangoplani72",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },

      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      }


    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://www.pngfind.com/pngs/m/136-1363736_express-js-icon-png-transparent-png.png",
      },

      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },

      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },

    ],
  },


  {
    title: "Others",
    skills: [
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Figma",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Figma-logo.svg/512px-Figma-logo.svg.png?20210804221519",
      },
      {
        name: "Trello",
        image: "https://cdn.worldvectorlogo.com/logos/trello.svg",
      },
      {
        name: "Canva",
        image: "https://www.vectorlogo.zone/logos/canva/canva-icon.svg",
      },
      {
        name: "Wordpress",
        image: "https://cdn.worldvectorlogo.com/logos/wordpress-2.svg",
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img:intershipImg,
    role: "Software Developer Intern",
    company: "Artiset",
    date: "January 2025 - July 2025",
    desc: "Worked on frontend tasks using HTML, CSS, and JavaScript. Gained hands-on experience in building responsive UI components and integrating APIs. Also focused on quality analysis by testing features, identifying bugs, and ensuring smooth user experience through regular feedback and improvements.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "Manual Testing",
      "Bug Reporting"
    ],
    doc: "https://drive.google.com/file/d/19slKyBaW5dsi4prNo5RqFNKGVLFZviaT/view?usp=sharing"
  }




];

export const education = [
  {
    id: 0,
    img: DPUimg,
    school: "Dr. D. Y. Patil School of Science and Technology, Thatwade, Pune",
    date: "Aug 2024 - Ongoing",
    grade: "9.18 CGPA",
    desc: "I am currently pursuing a Master's degree in Computer Applications (MCA) at DY Patil School of Science and Technology, Pune. I have maintained a strong academic record and have been recognized for my consistent performance. My coursework covers advanced topics such as Data Structures, Algorithms, Operating Systems, Computer Networks, Compiler Design, Blockchain Technology, and Data Analytics. I am focused on building a strong foundation in both theoretical concepts and practical applications in the field of computer science.",
    degree: "Master of Computer Application",
  },
  {
    id: 1,
    img: hnsImg,
    school: "Shree H.N. Shukla Group of Colleges, Rajkot, Gujarat",
    date: "Aug 2021 - July 2024",
    grade: "First Distinction - CGPA 8.17",
    desc: "I completed my Bachelor's degree in Computer Applications (BCA) from Shree H. N. Shukla Group of Colleges with a strong academic record. The program equipped me with a solid foundation in programming, web development, databases, and software engineering. It also helped me build strong logical thinking and problem-solving skills through hands-on projects and practical coursework.",
    degree: "Bachelors of Computer Application",
  },
  {
    id: 2,
    img: TapasviIMG,
    school: "Tapasvi School,Rajkot, Gujarat",
    date: "June 2020 - March 2021",
    grade: "69.20%",
    desc: "I completed my 12th grade in Commerce from Tapasvi English Medium School, Rajkot, with a strong academic performance. During this time, I developed an interest in technology and business, which later motivated me to pursue a career in computer applications.",
    degree: "HSC (XII), Commerce",
  },
  {
    id: 3,
    img: educationIMG,
    school: "Shree G.K. Dholakiya School,Rajkot, Gujarat",
    date: "June 2018 - March 2019",
    grade: "73.40%",
    desc: "I completed my 10th grade from Shree G.K. Dholakiya School, Rajkot, with a strong academic performance. This foundational education helped me develop a keen interest in mathematics, which later influenced my choice to pursue computer applications.",
    degree: "SSC (X)"
  }
];

export const projects = [

    {
    id: 9,
    title: "Disha Recruitment & Consulting",
    date: "January 2026",
    description:"A modern recruitment and job consulting website built with React.js, designed to showcase live job opportunities, capture employer and candidate enquiries, and enable direct engagement through WhatsApp with a fast, static, and user-friendly experience.",
    image: projectImg8,
    tags: ["React Js","Vite App","Tailwind CSS"],
    category: "web app",
    //github: "https://github.com/karangoplani72",
    webapp: "https://dishahire.com/",
    member: [
      {
        name: "Karan Goplani",
        img: "https://avatars.githubusercontent.com/u/92224864?s=400&u=1d609fde501621d9b0758f5c117dfdfdcd9d7462&v=4",
        linkedin: "https://www.linkedin.com/in/karangoplani72/",
        github: "https://github.com/karangoplani72",
      },
    ],
  },
  
  
    {
    id: 2,
    title: "NailStudio React App",
    date: "January 2026",
    description:"A comprehensive full-stack web application for a Nail Studio, built with React.js for the frontend and Node.js with Express.js for the backend, featuring service listings, appointment booking, user authentication, and admin management functionalities.",
    image: projectImg9,
    tags: ["React Js","Vite App","Tailwind CSS","Node Js","Express Js","MongoDB"],
    category: "web app",
    //github: "https://github.com/karangoplani72",
    webapp: "https://anajliis-nail-art.vercel.app/",
    member: [
      {
        name: "Karan Goplani",
        img: "https://avatars.githubusercontent.com/u/92224864?s=400&u=1d609fde501621d9b0758f5c117dfdfdcd9d7462&v=4",
        linkedin: "https://www.linkedin.com/in/karangoplani72/",
        github: "https://github.com/karangoplani72",
      },
    ],
  },
    {
    id: 6,
    title: "Visual DSA",
    date: "November 2025",
    description:" An interactive web application that visually demonstrates data structures and algorithms using React.js, enhancing understanding through dynamic animations and user engagement.",
    image: projectImg6,
    tags: ["React Js"],
    category: "web app",
    //github: "https://github.com/karangoplani72",
    webapp: "https://visual-dsa-pied.vercel.app/",
    member: [
      {
        name: "Karan Goplani",
        img: "https://avatars.githubusercontent.com/u/92224864?s=400&u=1d609fde501621d9b0758f5c117dfdfdcd9d7462&v=4",
        linkedin: "https://www.linkedin.com/in/karangoplani72/",
        github: "https://github.com/karangoplani72",
      },
    ],
  },
  {
    id: 7,
    title: "Visual Network",
    date: "November 2025",
    description:" An interactive web application that visually demonstrates network concepts and protocols using React.js, enhancing understanding through dynamic animations and user engagement.",
    image: projectImg7,
    tags: ["HTML", "CSS", "JavaScript", "Python (Flask)"],
    category: "web app",
    //github: "https://github.com/karangoplani72",
    webapp: "https://visualnetwork.vercel.app/",
    member: [
      {
        name: "Karan Goplani",
        img: "https://avatars.githubusercontent.com/u/92224864?s=400&u=1d609fde501621d9b0758f5c117dfdfdcd9d7462&v=4",
        linkedin: "https://www.linkedin.com/in/karangoplani72/",
        github: "https://github.com/karangoplani72",
      },
    ],
  },
  {
    id: 3,
    title: "Writer Portfolio Website",
    date: "JUNE 2025",
    description:
      "A creative and responsive personal portfolio website built using HTML, CSS, and subtle animations to showcase writing and storytelling.",
    image: projectImg4,
    tags: ["HTML", "CSS", "React Js", "nodejs", "MySQL"],
    category: "web app",
    //github: "https://github.com/karangoplani72",
    webapp:"https://kamya-portfolio.vercel.app/",
    member: [
      {
        name: "Karan Goplani",
        img: "https://avatars.githubusercontent.com/u/92224864?s=400&u=1d609fde501621d9b0758f5c117dfdfdcd9d7462&v=4",
        linkedin: "https://www.linkedin.com/in/karangoplani72/",
        github: "https://github.com/karangoplani72",
      },
    ],
  },
  {
    id: 2,
    title: "Nail Art Studio",
    date: "MAY 2025",
    description:
      "A PHP-based dynamic website for a Nail Studio featuring service listings, appointment booking, and admin management.",
    image: projectImg3,
    tags: ["HTML", "CSS", "JavaScript", "MySQL", "PHP"],
    category: "web app",
    //github: "",
    webapp: "#",
    member: [
      {
        name: "Karan Goplani",
        img: "https://avatars.githubusercontent.com/u/92224864?s=400&u=1d609fde501621d9b0758f5c117dfdfdcd9d7462&v=4",
        linkedin: "https://www.linkedin.com/in/karangoplani72/",
        github: "https://github.com/karangoplani72",
      },
    ],
  },
  {
    id: 4,
    title: "Editor Portfolio Website",
    date: "JULY 2025",
    description:"A dynamic and responsive editing-portfolio site built using modern web technologies,showcasing visual media and design work with intuitive navigation and clean, engaging layout.",
    image: projectImg5,
    tags: ["React Js"],
    category: "web app",
    //github: "https://github.com/karangoplani72",
    webapp: "https://dhruv-edits.vercel.app/",
    member: [
      {
        name: "Karan Goplani",
        img: "https://avatars.githubusercontent.com/u/92224864?s=400&u=1d609fde501621d9b0758f5c117dfdfdcd9d7462&v=4",
        linkedin: "https://www.linkedin.com/in/karangoplani72/",
        github: "https://github.com/karangoplani72",
      },
    ],
  },
    {
    id: 1,
    title: "Personal Portfolio Website",
    date: "April 2025",
    description:
      "A modern and responsive personal portfolio website built using React.js.",
    image: projectImg,
    tags: [
      "React Js"
    ],
    category: "web app",
    //github: "https://github.com/karangoplani72/",
    webapp: "https://karanportfolio-lemon.vercel.app/",
    member: [
      {
        name: "Karan Goplani",
        img: "https://avatars.githubusercontent.com/u/92224864?s=400&u=1d609fde501621d9b0758f5c117dfdfdcd9d7462&v=4",
        linkedin: "https://www.linkedin.com/in/karangoplani72/",
        github: "https://github.com/karangoplani72",
      },
    ],
  },
  // {
  //   id: 8,
  //   title: "Nail Art Studio",
  //   date: "MAY 2025",
  //   description:
  //     "A responsive React.js website for a Nail Studio with service showcase, online booking, and interactive user interface.",
  //   image: projectImg3,
  //   tags: ["React Js"],
  //   category: "web app",
  //   //github: "https://github.com/karangoplani72",
  //   webapp:"https://nail-studio-sepia.vercel.app/nail-studio",
  //   member: [
  //     {
  //       name: "Karan Goplani",
  //       img: "https://avatars.githubusercontent.com/u/92224864?s=400&u=1d609fde501621d9b0758f5c117dfdfdcd9d7462&v=4",
  //       linkedin: "https://www.linkedin.com/in/karangoplani72/",
  //       github: "https://github.com/karangoplani72",
  //     },
  //   ],
  // },




  //{
  //new projects to be added here
  //}
];
